export default {
  daring: [
    { icon: 'mdi-account-clock', title: 'Kelola Diklat', event: 'onDetailDiklat', akses: true },
    { icon: 'mdi-pencil', title: 'Ubah', event: 'onEditDiklat', akses: 'lpd-diklat.update' },
    { icon: 'mdi-delete', title: 'Hapus', event: 'onDeleteDiklat', akses: 'lpd-diklat.delete' },
  ],
  luring: [
    { icon: 'mdi-eye', title: 'Detail', event: 'onShowBimtek', akses: true },
    { icon: 'mdi-account-clock', title: 'Kelola Diklat', event: 'onDetailDiklat', akses: true },
    { icon: 'mdi-pencil', title: 'Ubah', event: 'onEditDiklat', akses: 'lpd-luring-diklat.update' },
    { icon: 'mdi-delete', title: 'Hapus', event: 'onDeleteDiklat', akses: 'lpd-luring-diklat.delete' },
  ],
  bcmp: [
    { icon: 'mdi-account-clock', title: 'Kelola Bimtek', event: 'onDetailDiklat', akses: true },
    { icon: 'mdi-pencil', title: 'Ubah', event: 'onEditDiklat', akses: 'bcmp-diklat.update' },
    { icon: 'mdi-delete', title: 'Hapus', event: 'onDeleteDiklat', akes: 'bcmp-diklat.delete' },
  ],
  refreshment: [
    { icon: 'mdi-eye', title: 'Detail', event: 'onShowBimtek', akses: true },
    { icon: 'mdi-account-clock', title: 'Kelola Bimtek', event: 'onDetailDiklat', akses: true },
    { icon: 'mdi-pencil', title: 'Ubah', event: 'onEditDiklat', akses: 'lpd-bimtek-diklat.update' },
    { icon: 'mdi-delete', title: 'Hapus', event: 'onDeleteDiklat', akes: 'lpd-bimtek-diklat.delete' },
  ],
};
